import styled from "styled-components";
import iconCoin from "../../../../../assets/images/Mini-Game/attempt-coin.svg";
import iconCoinSuper from "../../../../../assets/images/Mini-Game/Coin (1).png";
import iconCoinNewYear from "../../../../../assets/images/Mini-Game/new-year-2025/bid.png";
import iconCoinSuperNewYear from "../../../../../assets/images/Mini-Game/new-year-2025/coin.png";
import iconCheck from "../../../../../assets/images/Mini-Game/icon-check.png";
import iconChangeCoins from "../../../../../assets/images/Mini-Game/icon-change-coins.png";
import { useNavigate } from "react-router";
import {
  ID_INVITE_USER,
  TYPE_GIVE_PIECE,
  useNewYear2025Theme,
} from "../../../../../helper/const";
import { useDispatch } from "react-redux";
import { getCookie, postDataApi } from "../../../../../config/service";
import API_PATH from "../../../../../config/API_PATH";
import {
  setDataPopupError,
  setOpenPopupGivePiece,
  setOpenPopupLogin,
  setOpenPopupPiece,
} from "../../../../../Redux/futures/mini-game/action";
import PATH from "../../../../../config/PATH";
import { useTranslation } from "react-i18next";
import { useLoginModal } from '@/contexts/LoginModalContext';

export default function ItemMission({
  data = {},
  isDaily,
  children,
  contentWarning,
  isShowWarning,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { openLogin } = useLoginModal();


  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  const handleInviteUser = async () => {
    if (!getCookie("token")) {
      return dispatch(setOpenPopupLogin(true));
    }

    const dataApi = await postDataApi(API_PATH.miniGameAddInviteLink);

    // lỗi
    if (!dataApi?.success && dataApi?.errorMessage) {
      return dispatch(
        setDataPopupError({
          isOpen: true,
          message: dataApi?.errorMessage,
        })
      );
    }

    dispatch(
      setOpenPopupGivePiece({
        isShow: true,
        link: `http://reverseauction.com.mm/mini-game/invite-user/${dataApi?.data?.code}`,
        type: TYPE_GIVE_PIECE.inviteUser,
      })
    );
  };

  const handleExcute = () => {
    dispatch(
      setOpenPopupPiece({
        isShowPopupPiece: false,
      })
    );
    if (!getCookie("token")) {
      return openLogin(() => navigate(data.link));
    }

    if (data.type === ID_INVITE_USER) {
      return handleInviteUser();
    }

    navigate(data.link);
  };

  return (
    <ContainerItem
      className={`item-mission-container-mini ${IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""
        }`}
    >
      {children ? (
        <>
          <div className='container-change-coins-mini container-change-coins-mini-reel'>
            <div className='mission-icon'>
              <div className='container-icon-mission'>
                <img src={iconChangeCoins} alt='' />
              </div>
              <div style={{ width: "100%" }}>
                <div className='mission-name'>
                  {t("mini_game.standard_missions.change_coins")}
                </div>
                <div className='mini-mission-footer'>
                  {t("mini_game.standard_missions.1_turn_1_coin")}
                </div>
                <div>{children}</div>
              </div>
            </div>
          </div>
          {contentWarning && isShowWarning ? (
            <div className='warning-change-turn'>
              {contentWarning}
              <div
                onClick={() => {
                  dispatch(
                    setOpenPopupPiece({
                      isShowPopupPiece: false,
                    })
                  );

                  navigate(PATH.PACKAGE);
                }}
              >
                {t("mini_game.standard_missions.buy_more_turns")}
              </div>
            </div>
          ) : null}
        </>
      ) : (
        <div className='d-flex flex-mission-icon'>
          <div className='mission-icon'>
            <div className='container-icon-mission'>
              <img src={data.icon} alt='' />
            </div>
            <div>
              <div className='mission-name'>{data?.name || ""}</div>
              {data.titleFooter ? (
                <div className='mini-mission-footer'>{data.titleFooter}</div>
              ) : (
                <div className='mission-total-coin'>
                  {data.normal_coin ? (
                    <>
                      <img
                        src={
                          IS_EVENT_NEW_YEAR_2025_THEME
                            ? iconCoinNewYear
                            : iconCoin
                        }
                        alt=''
                        className='icon-coin'
                      />
                      <span className={`total`}>+{data.normal_coin}</span>
                    </>
                  ) : null}
                  {data.supper_coin ? (
                    <>
                      <img
                        src={
                          IS_EVENT_NEW_YEAR_2025_THEME
                            ? iconCoinSuperNewYear
                            : iconCoinSuper
                        }
                        alt=''
                        className='icon-coin'
                      />
                      <span className='total color-red'>
                        +{data.supper_coin}
                      </span>
                    </>
                  ) : null}
                </div>
              )}
            </div>
          </div>
          {!data.completed ? (
            isDaily ? (
              <div className='excute-daily' onClick={handleExcute}>
                {data.contentButton
                  ? data.contentButton
                  : t("mini_game.standard_missions.execute")}
              </div>
            ) : (
              <div className='excute-standard' onClick={handleExcute}>
                {t("mini_game.standard_missions.execute")}
              </div>
            )
          ) : (
            <div className='mission-status'>
              <img src={iconCheck} alt='' />
              <span className='title-status'>
                {t("mini_game.standard_missions.claimed")}
              </span>
            </div>
          )}
        </div>
      )}
    </ContainerItem>
  );
}

const ContainerItem = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1); // X, Y, blur, color
  border-radius: 20px;
  padding: 16px;
  position: relative;

  .flex-mission-icon {
    display: grid !important;
    grid-template-columns: calc(100% - 120px) 120px;
  }

  .mini-mission-footer {
    font-style: italic;
    color: #954911;
    opacity: 0.7;

    @media (max-width: 500px) {
      font-size: 12px;
    }
  }

  .excute-standard {
    background-color: #f97a1c;
    color: #ffffff;
    font-weight: 600;
    font-size: 18px;
    /* width: 100px; */
    padding: 0 8px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    cursor: pointer;
  }
  @media (max-width: 625px) {
    .excute-standard {
      font-size: 13px;
      width: 90px;
      height: 40px;
    }

    .flex-mission-icon {
      display: grid !important;
      grid-template-columns: calc(100% - 90px) 90px;
    }
  }

  @media (max-width: 468px) {
    .excute-standard {
      font-size: 13px;
    }
  }
  @media (max-width: 375px) {
    .excute-standard {
      width: 80px;
      height: 35px;
      font-size: 12px;
    }

    .flex-mission-icon {
      display: grid !important;
      grid-template-columns: calc(100% - 80px) 80px;
    }
  }

  .excute-daily {
    color: #f97a1c;
    font-weight: 600;
    font-size: 18px;
    width: 100px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #f97a1c;
    border-radius: 25px;
    cursor: pointer;

    @media (max-width: 625px) {
      font-size: 14px;
      width: 80px;
      height: 40px;
    }

    @media (max-width: 468px) {
      font-size: 13px;
    }

    @media (max-width: 375px) {
      width: 70px;
      height: 35px;
      font-size: 12px;
    }
  }

  .d-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .icon-coin {
    width: 35px;

    @media (max-width: 576px) {
      width: 25px;
    }
  }

  .mission-status {
    display: flex;
    align-items: center;
    padding: 8px 20px;
    gap: 6px;
    background-color: #e3fbcc;
    border-bottom-left-radius: 20px;
    position: absolute;
    right: 0px;
    top: 0%;
    /* transform: translateY(-50%); */

    .title-status {
      color: #66c61c;
      font-size: 18px;
      font-weight: 600;
    }

    @media (max-width: 576px) {
      /* padding: 4px 10px;
      gap: 4px; */

      .title-status {
        font-size: 14px;
      }
    }
  }

  .mission-total-coin {
    display: flex;
    gap: 8px;
    align-items: center;
    .total {
      color: #f97a1c;
      font-size: 18px;
      font-weight: bold;
    }

    .color-red {
      color: #f04438;
      padding-top: 5px;
    }

    @media (max-width: 576px) {
      .total {
        font-size: 14px;
      }
    }
  }

  .mission-name {
    color: #954911;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 8px;

    @media (max-width: 625px) {
      font-size: 16px !important;
    }

    @media (max-width: 500px) {
      font-size: 14px !important;
    }

    @media (max-width: 425px) {
      font-size: 12px !important;
    }
  }

  .mission-icon {
    display: grid;
    gap: 16px;
    grid-template-columns: 60px auto;

    @media (max-width: 576px) {
      grid-template-columns: 48px auto;
    }

    @media (max-width: 468px) {
      gap: 8px;
    }

    @media (max-width: 425px) {
      grid-template-columns: 43px auto;
    }

    @media (max-width: 386px) {
      grid-template-columns: 38px auto;
    }

    @media (max-width: 375px) {
      gap: 4px;
    }
  }

  .container-icon-mission {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e5e7eb;

    @media (max-width: 576px) {
      width: 48px !important;
      height: 48px !important;
    }

    @media (max-width: 425px) {
      width: 40px !important;
      height: 40px !important;
    }

    @media (max-width: 386px) {
      width: 35px !important;
      height: 35px !important;

      img {
        max-width: 20px !important;
      }
    }
  }

  @media (min-width: 992px) {
    .excute-daily:hover,
    .excute-standard:hover {
      scale: 1.05;
      transition: 0.3s ease-in-out;
    }
  }

  @media (max-width: 576px) {
    .mission-name {
      font-size: 16px;
    }
    .mission-status {
      padding: 8px 10px;
      img {
        width: 15px;
      }
      .title-status {
        font-size: 13px;
      }
    }

    .excute-daily {
      width: 80px;
      height: 40px;
      font-size: 13px;
    }

    .container-icon-mission img {
      max-width: 25px;
    }

    .mission-total-coin .total {
      font-size: 13px;
    }

    .icon-coin {
      width: 25px;
    }

    .mission-total-coin {
      gap: 5px;
    }
  }

  @media (max-width: 412px) {
    padding: 16px 8px;
  }

  &.new-year-25-theme {
    .excute-standard {
      background-color: #d61717;
    }

    .excute-daily {
      border: 1px solid #d61717;
      color: #d61717;
      background-color: #fbe8e8;
    }

    .mission-total-coin {
      .total {
        color: #d61717;
      }
    }

    .mission-name {
      color: #800E0E;
    }

    .btn-change-turn {
      background-color: #d61717;
    }
  }
`;
